import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import Parser from 'html-react-parser';

function LegendePopup({ id, item, itemImg }) {

    const [afficher, setAfficher] = useState(false);
    const [texte, setTexte] = useState("");

    const changerAffichage = () => {
        setAfficher(!afficher);
    }

    useEffect(() => {
        let isSubscribed = true;
        fetch(process.env.PUBLIC_URL + "/" + item.thematique + ".html",
            {
                'headers': {
                    'Content-Type': 'text/plain',
                    'Accept': 'text/plain',
                }
            })
            .then(result => result.text())
            .then(resultat => {
                if (isSubscribed) {
                    setTexte(resultat);
                }
            })
        return () => isSubscribed = false
    }, [item.thematique])

    return <>
        <div key={id} className="entete_block entete_popup" onClick={changerAffichage}>
            <img src={itemImg} className="entete_picto" alt={item.titre} />
            <div className="entete_block_texte">
                <div className="entete_titre">{item.titre}</div>
                {
                    item.soustitre.length > 1 ?
                        <div className="entete_soustitre">{item.soustitre}</div>
                        :
                        null
                }
            </div>
        </div>
        {
            afficher ?
                <div id="popup-ajout" className="entete_popup_contenu">
                    <div onClick={() => changerAffichage()} className="ol-popup-closer-ajout">
                        <CloseIcon className="bouttonfermer"></CloseIcon>
                    </div>
                    <div className={"popup"}>
                        {Parser(texte)}
                    </div>
                </div> :
                null
        }
    </>
}

export default LegendePopup
